import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Responsive } from '~/components';
import { Mobile, Desktop } from './responsive';
import {
  getSelectedMatchLineupRequest,
  getSelectedMatchTeamStatsRequest,
} from '~/store/modules/matches/actions';

export default function Previous() {
  const {
    selectedMatch: { data: selectedMatch, loading: isFetchingMatch },
    lineup: {
      data: lineup,
      loading: isFetchingLineUp,
      failed: lineupFetchFailed,
    },
    stats: {
      data: statsData,
      loading: isFetchingStats,
      failed: teamStatsFailed,
    },
  } = useSelector(state => state.matches);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedMatch) {
      dispatch(getSelectedMatchLineupRequest(selectedMatch.id));
    }
    if (selectedMatch) {
      dispatch(getSelectedMatchTeamStatsRequest(selectedMatch.id));
    }
  }, [dispatch, selectedMatch]);

  const previousProps = {
    selectedMatch,
    lineup,
    lineupFetchFailed,
    statsData,
    teamStatsFailed,
    isFetching: isFetchingMatch || isFetchingLineUp || isFetchingStats,
  };

  const renderComponent = () => {
    return (
      <Responsive
        md={<Mobile {...previousProps} />}
        lg={<Desktop tabletMode {...previousProps} />}
        xl={<Desktop {...previousProps} />}
      />
    );
  };

  return useMemo(renderComponent, [
    selectedMatch,
    lineup,
    statsData,
    isFetchingMatch || isFetchingLineUp || isFetchingStats,
  ]);
}
